<template>
  <v-container
    fluid
    fill-height
    grid-list-md
  >
    <v-layout
      row
      wrap
    >
      <v-flex>
        <v-progress-linear
          indeterminate
          height="2"
          v-if="loading"
        ></v-progress-linear>
        <router-view v-else-if="country"></router-view>

        <v-alert
          :value="true"
          color="white"
          class="grey--text"
          icon="info"
          v-if="!country && !loading"
        >
          יש לבחור מדינה מהשדה למעלה
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GeneralDetails from "./country/GeneralDetails";
import { format } from "date-fns";

export default {
  data() {
    return {
      tab: null,
      // tabs: ["פרטים כללים", "אנשי קשר", "יומן פעילות", "מפה"],
      loading: false
    };
  },
  computed: {
    countryId() {
      return this.$route.params.id;
    },
    country() {
      return this.$store.getters["entity"]("countries", this.countryId);
    },
    selectedCountry: {
      get() {
        return this.$store.getters["countries/selectedCountry"];
      },
      set(val) {
        this.$store.commit("countries/SET_SELECTED_COUNTRY", val);
      }
    }
  },
  watch: {
    countryId: function(val) {
      if (val) {
        this.getDataFromApi();
      }
    }
  },
  methods: {
    getData(key) {
      return this[key];
    },
    fetch() {
      this.$store
        .dispatch("API_GET", {
          url: `/countries/${this.countryId}`,
          entityType: "countries",
          schema: "countryListSchema",
          replace: false
        })
        // .then(() => {
        //   // this.totalPartners = totalResults;
        // })
        .catch(err => {
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.loading = false;
          // this.updateUrlQuery();
        });
    },
    getDataFromApi() {
      this.loading = true;
      this.fetch();
    }
  },
  beforeMount() {
    this.selectedCountry = this.$route.params.id || null;
  },
  mounted() {
    if (this.countryId) {
      this.getDataFromApi();
    }
  },
  beforeDestroy() {
    this.selectedCountry = null;
  },
  watch: {
    "$route.path": function(val) {
      this.selectedCountry = this.$route.params.id || null;
      if (this.selectedCountry) {
        this.getDataFromApi();
      }
    }
  },
  components: {
    GeneralDetails
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/countries/Country.vue